import { watchFetchCoOpDealerEstimates } from './fetchCoOpDealerEstimates';
import { watchFetchCoOpDealerRequests } from './fetchCoOpDealerRequests';
import { watchFetchCoOpGlobalSettings } from './fetchCoOpGlobalSettings';
import { watchFetchCoOpRegionBudgets } from './fetchCoOpRegionBudgets';
import { watchFetchCoOpRequest } from './fetchCoOpRequest';
import { watchFetchCoOpRequests } from './fetchCoOpRequests';
import { watchFetchCoOpRequestStatuses } from './fetchCoOpRequestStatuses';
import { watchFetchCoOpSalesDistrictBudgets } from './fetchCoOpSalesDistrictBudgets';
import { watchUpdateCoOpCampaignType } from './updateCoOpCampaignType';
import { watchUpdateCoOpDealerEstimate } from './updateCoOpDealerEstimate';
import { watchUpdateCoOpGlobalSettings } from './updateCoOpGlobalSettings';
import { watchUpdateCoOpRegionBudgets } from './updateCoOpRegionBudgets';
import { watchUpdateCoOpRequest } from './updateCoOpRequest';
import { watchUpdateCoOpSalesDistrictBudgets } from './updateCoOpSalesDistrictBudgets';
import { watchUpdateCoOpState } from './updateCoOpState';
import { watchUpdateCoOpStatus } from './updateCoOpStatus';

export const coOpSagas = [
  watchFetchCoOpDealerEstimates(),
  watchFetchCoOpDealerRequests(),
  watchFetchCoOpGlobalSettings(),
  watchFetchCoOpRegionBudgets(),
  watchFetchCoOpRequest(),
  watchFetchCoOpRequests(),
  watchFetchCoOpRequestStatuses(),
  watchFetchCoOpSalesDistrictBudgets(),
  watchUpdateCoOpCampaignType(),
  watchUpdateCoOpDealerEstimate(),
  watchUpdateCoOpGlobalSettings(),
  watchUpdateCoOpRegionBudgets(),
  watchUpdateCoOpRequest(),
  watchUpdateCoOpSalesDistrictBudgets(),
  watchUpdateCoOpState(),
  watchUpdateCoOpStatus()
];
